import { defineMessages } from 'react-intl';

/** The copy of Browse v2 (design browse-v2 a, b, c). */
export const browseMessages = defineMessages({
  // The native apps read `title`. The web page is "Search" since navigation v2 (owner, 2026-10-23).
  title: { id: 'app.sml.browse.header.title', defaultMessage: 'Browse the catalogue' },
  pageTitle: { id: 'app.sml.browse.header.titleSearch', defaultMessage: 'Search' },
  subtitle: {
    id: 'app.sml.browse.header.subtitleServices',
    defaultMessage: 'Search 10+ services. Follow anything to start tracking it.',
  },
  searchTitle: { id: 'app.sml.browse.search.title', defaultMessage: 'Search' },
  searchSub: { id: 'app.sml.browse.search.sub', defaultMessage: 'Artists, tracks and playlists. Searching is free.' },
  slashHint: { id: 'app.sml.browse.search.slashHint', defaultMessage: '/ to focus' },
  placeholder: {
    id: 'app.sml.browse.search.placeholder',
    defaultMessage: 'Search an artist, a track or a playlist, or paste a link',
  },
  placeholderShort: { id: 'app.sml.browse.search.placeholderShort', defaultMessage: 'Artist, track, playlist or link' },
  clearQuery: { id: 'app.sml.browse.search.clear', defaultMessage: 'Clear the search' },
  typeAll: { id: 'app.sml.browse.type.all', defaultMessage: 'All' },
  typeArtists: { id: 'app.sml.browse.type.artists', defaultMessage: 'Artists' },
  typeTracks: { id: 'app.sml.browse.type.tracks', defaultMessage: 'Tracks' },
  typePlaylists: { id: 'app.sml.browse.type.playlists', defaultMessage: 'Playlists' },
  typePlaylistsShort: { id: 'app.sml.browse.type.playlistsShort', defaultMessage: 'Lists' },
  typeSwitch: { id: 'app.sml.browse.type.label', defaultMessage: 'Result type' },
  sortLabel: { id: 'app.sml.browse.sort.label', defaultMessage: 'Sort' },
  sortMatch: { id: 'app.sml.browse.sort.match', defaultMessage: 'Best match' },
  sortReach: { id: 'app.sml.browse.sort.reach', defaultMessage: 'Playlist reach' },
  sortPlaylists: { id: 'app.sml.browse.sort.playlists', defaultMessage: 'Most playlists' },
  sortChange: { id: 'app.sml.browse.sort.change7d', defaultMessage: '7-day change' },
  sortFollowers: { id: 'app.sml.browse.sort.followers', defaultMessage: 'Followers' },
  genreLabel: { id: 'app.sml.browse.filter.genre', defaultMessage: 'Genre' },
  countryLabel: { id: 'app.sml.browse.filter.country', defaultMessage: 'Country' },
  serviceLabel: { id: 'app.sml.browse.filter.service', defaultMessage: 'Service' },
  serviceAll: { id: 'app.sml.browse.filter.serviceAll', defaultMessage: 'All' },
  anyValue: { id: 'app.sml.browse.filter.any', defaultMessage: 'Any' },
  globalValue: { id: 'app.sml.browse.filter.global', defaultMessage: 'Global' },
  hideFollowed: { id: 'app.sml.browse.filter.hideFollowed', defaultMessage: 'Hide followed' },
  clearFilters: { id: 'app.sml.browse.filter.clear', defaultMessage: 'Clear filters' },
  filters: { id: 'app.sml.browse.filter.sheetButton', defaultMessage: 'Filters' },
  showResults: {
    id: 'app.sml.browse.filter.showResults',
    defaultMessage: '{count, plural, one {Show # result} other {Show # results}}',
  },
  pasteLink: { id: 'app.sml.browse.pasteLink', defaultMessage: 'Paste a playlist link' },
  topResult: { id: 'app.sml.browse.top.title', defaultMessage: 'Top result' },
  numbersAsOf: { id: 'app.sml.browse.numbersAsOf', defaultMessage: 'Numbers as of {date}' },
  kindArtist: { id: 'app.sml.browse.kind.artist', defaultMessage: 'Artist' },
  kindTrack: { id: 'app.sml.browse.kind.track', defaultMessage: 'Track' },
  topTracksBy: { id: 'app.sml.browse.top.tracksBy', defaultMessage: 'Top tracks by {artist}' },
  openArtist: { id: 'app.sml.browse.open.artist', defaultMessage: 'Open artist' },
  openTrack: { id: 'app.sml.browse.open.track', defaultMessage: 'Open track' },
  statFollowers: { id: 'app.sml.browse.stat.followers', defaultMessage: 'Followers' },
  statReach: { id: 'app.sml.browse.stat.reach', defaultMessage: 'Reach' },
  statPlaylists: { id: 'app.sml.browse.stat.playlists', defaultMessage: 'Playlists' },
  stat7d: { id: 'app.sml.browse.stat.change7d', defaultMessage: '7 days' },
  colArtist: { id: 'app.sml.browse.col.artist', defaultMessage: 'Artist' },
  colTrack: { id: 'app.sml.browse.col.track', defaultMessage: 'Track' },
  colToOpen: { id: 'app.sml.browse.col.toOpen', defaultMessage: 'To open' },
  results: {
    id: 'app.sml.browse.results.count',
    defaultMessage: '{count, plural, one {# result} other {# results}}',
  },
  resultsCapped: { id: 'app.sml.browse.results.capped', defaultMessage: '{count}+ results' },
  playlistsFree: { id: 'app.sml.browse.results.playlistsFree', defaultMessage: 'Opening a playlist is free.' },
  seeAll: { id: 'app.sml.browse.results.seeAll', defaultMessage: 'See all {count}' },
  showMore: { id: 'app.sml.browse.results.showMore', defaultMessage: 'Show more' },
  shownOf: { id: 'app.sml.browse.results.shownOf', defaultMessage: '{shown} of {total} shown' },
  playlistFollowers: {
    id: 'app.sml.browse.playlist.followers',
    defaultMessage: '{count, plural, one {# follower} other {# followers}}',
  },
  playlistSongs: {
    id: 'app.sml.browse.playlist.songs',
    defaultMessage: '{count, plural, one {# song} other {# songs}}',
  },
  reachShort: { id: 'app.sml.browse.row.reachShort', defaultMessage: '{value} reach' },
  playlistsShort: {
    id: 'app.sml.browse.row.playlistsShort',
    defaultMessage: '{count, plural, one {# playlist} other {# playlists}}',
  },
  costCredit: { id: 'app.sml.browse.cost.credit', defaultMessage: '1 credit' },
  costLastCredit: { id: 'app.sml.browse.cost.lastCredit', defaultMessage: 'Last credit' },
  costNoCredits: { id: 'app.sml.browse.cost.none', defaultMessage: 'No credits' },
  costOpenedToday: { id: 'app.sml.browse.cost.openedToday', defaultMessage: 'Opened today' },
  costFollowed: { id: 'app.sml.browse.cost.followed', defaultMessage: 'Followed' },
  costFree: { id: 'app.sml.browse.cost.free', defaultMessage: 'Free' },
  creditToOpen: { id: 'app.sml.browse.cost.creditToOpen', defaultMessage: '1 credit to open' },
  follow: { id: 'app.sml.browse.follow', defaultMessage: 'Follow' },
  following: { id: 'app.sml.browse.following', defaultMessage: 'Following' },
  trackPlaylist: { id: 'app.sml.browse.trackPlaylist', defaultMessage: 'Track playlist' },
  tracking: { id: 'app.sml.browse.tracking', defaultMessage: 'Tracking' },
  slotsFull: { id: 'app.sml.browse.slotsFull', defaultMessage: '{used} of {limit}' },
  followLabel: { id: 'app.sml.browse.followLabel', defaultMessage: 'Follow {name}' },
  unfollowLabel: { id: 'app.sml.browse.unfollowLabel', defaultMessage: 'Stop following {name}' },
});

/** The copy of the states and the rail (design b, c). */
export const browseStateMessages = defineMessages({
  tryTitle: { id: 'app.sml.browse.first.try', defaultMessage: 'Try' },
  tryLink: { id: 'app.sml.browse.first.tryLink', defaultMessage: 'A Spotify playlist link' },
  movingTitle: { id: 'app.sml.browse.first.movingTitle', defaultMessage: 'Moving this week' },
  movingSub: {
    id: 'app.sml.browse.first.movingSub',
    defaultMessage: 'The artists that gained the most playlist reach in 7 days',
  },
  openTrends: { id: 'app.sml.browse.first.openTrends', defaultMessage: 'Open Trends' },
  howTitle: { id: 'app.sml.browse.how.title', defaultMessage: 'How browse credits work' },
  ruleSearchFree: {
    id: 'app.sml.browse.how.searchFree',
    defaultMessage: 'Search is free. Look at as many results as you like.',
  },
  ruleOpenCosts: { id: 'app.sml.browse.how.openCosts', defaultMessage: 'Opening a new artist or track uses 1 credit.' },
  ruleAgainFree: {
    id: 'app.sml.browse.how.againFree',
    defaultMessage: 'Opening it again today, a playlist, or anything you follow is free.',
  },
  noResultsTitle: { id: 'app.sml.browse.empty.title', defaultMessage: 'No results for “{query}”' },
  noResultsBody: { id: 'app.sml.browse.empty.body', defaultMessage: 'Check the spelling, or use fewer words.' },
  noResultsFilterOn: { id: 'app.sml.browse.empty.filterOn', defaultMessage: 'A filter is on.' },
  searchInstead: { id: 'app.sml.browse.empty.searchInstead', defaultMessage: 'Search “{name}”' },
  clearFilter: { id: 'app.sml.browse.empty.clearFilter', defaultMessage: 'Clear the filter' },
  pasteHint: {
    id: 'app.sml.browse.empty.pasteHint',
    defaultMessage: 'Search for a playlist that is not here? <link>Paste its link</link>',
  },
  errorTitle: { id: 'app.sml.browse.error.title', defaultMessage: 'Search failed' },
  errorBody: {
    id: 'app.sml.browse.error.body',
    defaultMessage: 'We could not reach the catalogue. Your credits are not used. Try again.',
  },
  errorRateLimit: { id: 'app.sml.browse.error.rateLimit', defaultMessage: 'Too many searches. Wait a minute.' },
  tryAgain: { id: 'app.sml.browse.error.tryAgain', defaultMessage: 'Try again' },
  resultsTitle: { id: 'app.sml.browse.results.title', defaultMessage: 'Results' },
  loading: { id: 'app.sml.browse.loading', defaultMessage: 'Searching' },
});

/** The copy of the credits rail and the credits sheet (design a1 rail, b5, b6, b7, c3). */
export const browseCreditMessages = defineMessages({
  title: { id: 'app.sml.browse.credits.title', defaultMessage: 'Browse credits' },
  left: { id: 'app.sml.browse.credits.left', defaultMessage: '{left} of {limit} left today' },
  leftShort: { id: 'app.sml.browse.credits.leftShort', defaultMessage: 'of {limit} left today' },
  used: { id: 'app.sml.browse.credits.used', defaultMessage: '{count} used' },
  resetsIn: { id: 'app.sml.browse.credits.resetsIn', defaultMessage: 'Resets 00:00 UTC · in {time}' },
  resetsInShort: { id: 'app.sml.browse.credits.resetsInShort', defaultMessage: 'Resets in {time}' },
  hoursMinutes: { id: 'app.sml.browse.credits.hoursMinutes', defaultMessage: '{hours} h {minutes} min' },
  minutesOnly: { id: 'app.sml.browse.credits.minutes', defaultMessage: '{minutes} min' },
  freeRules: {
    id: 'app.sml.browse.credits.freeRules',
    defaultMessage: 'Search, playlists, and what you follow are free.',
  },
  costRule: {
    id: 'app.sml.browse.credits.costRule',
    defaultMessage: 'Opening a new artist or track uses 1 credit. Opening it again today is free.',
  },
  openedToday: { id: 'app.sml.browse.credits.openedToday', defaultMessage: 'Opened today · {count}' },
  nextPlan: { id: 'app.sml.browse.credits.nextPlan', defaultMessage: '{plan}: {count} a day' },
  seePlans: { id: 'app.sml.browse.credits.seePlans', defaultMessage: 'See plans' },
  comparePlans: { id: 'app.sml.browse.credits.comparePlans', defaultMessage: 'Compare all plans' },
  usedUpTitle: {
    id: 'app.sml.browse.credits.usedUpTitle',
    defaultMessage: 'You used all {limit} browse credits today',
  },
  usedUpBody: {
    id: 'app.sml.browse.credits.usedUpBody',
    defaultMessage: 'Search still works. What you follow and what you opened today still opens.',
  },
  newCreditsIn: { id: 'app.sml.browse.credits.newCreditsIn', defaultMessage: 'New credits at 00:00 UTC · in {time}' },
  usedOf: { id: 'app.sml.browse.credits.usedOf', defaultMessage: '{used} of {limit} used' },
  yourPlan: { id: 'app.sml.browse.credits.yourPlan', defaultMessage: 'Your plan' },
  timesMore: { id: 'app.sml.browse.credits.timesMore', defaultMessage: '{times}× more' },
  opensADay: { id: 'app.sml.browse.credits.opensADay', defaultMessage: '{count} opens a day' },
  pricePerMonth: {
    id: 'app.sml.browse.credits.pricePerMonth',
    defaultMessage: '{price, number, ::currency/USD precision-integer} / month',
  },
  followLimits: {
    id: 'app.sml.browse.credits.followLimits',
    defaultMessage: 'Follow {artists} artists, {tracks} tracks',
  },
  filterCountry: { id: 'app.sml.browse.credits.filterCountry', defaultMessage: 'Filter by country' },
  filterCountryService: {
    id: 'app.sml.browse.credits.filterCountryService',
    defaultMessage: 'Filter by country and service',
  },
  historyDays: { id: 'app.sml.browse.credits.historyDays', defaultMessage: '{days} days of history' },
  upgradeTo: { id: 'app.sml.browse.credits.upgradeTo', defaultMessage: 'Upgrade to {plan}' },
  followTip: {
    id: 'app.sml.browse.credits.followTip',
    defaultMessage: 'Tip: follow an artist to open it any time for free.',
  },
  askOwner: { id: 'app.sml.browse.credits.askOwner', defaultMessage: 'Ask {owner} for more credits' },
  ownerPicksPlan: {
    id: 'app.sml.browse.credits.ownerPicksPlan',
    defaultMessage: '{owner} owns this workspace and picks its plan.',
  },
  nativeNote: {
    id: 'app.sml.browse.credits.nativeNote',
    defaultMessage: 'To get more opens a day, change your plan in the MUSIC24 app: Settings → Subscription.',
  },
  freeUpsell: {
    id: 'app.sml.browse.credits.freeUpsell',
    defaultMessage:
      'The {plan} plan gives {count} opens a day and {tracks} track follows. {price, number, ::currency/USD precision-integer} / month',
  },
  trialTitle: { id: 'app.sml.browse.trial.titlePlan', defaultMessage: 'Try {plan} free for {days} days' },
  trialBody: {
    id: 'app.sml.browse.trial.body',
    defaultMessage: '{count} opens a day, the country filter and more follows. No card needed.',
  },
  trialStart: { id: 'app.sml.browse.trial.start', defaultMessage: 'Start the free trial' },
  trialStarted: { id: 'app.sml.browse.trial.started', defaultMessage: 'Your 7-day trial started.' },
  trialFailed: { id: 'app.sml.browse.trial.failed', defaultMessage: 'We could not start the trial. Try again.' },
  slotsTitle: { id: 'app.sml.browse.slots.title', defaultMessage: 'Follow slots' },
  slotsWorkspace: { id: 'app.sml.browse.slots.workspace', defaultMessage: 'Workspace' },
  slotsArtists: { id: 'app.sml.browse.slots.artists', defaultMessage: 'Artists' },
  slotsTracks: { id: 'app.sml.browse.slots.tracks', defaultMessage: 'Tracks' },
  slotsOf: { id: 'app.sml.browse.slots.of', defaultMessage: '{used} of {limit}' },
  slotsNote: {
    id: 'app.sml.browse.slots.note',
    defaultMessage: 'Followed items show on Watchlist and open for free.',
  },
  slotsFullNote: {
    id: 'app.sml.browse.slots.fullNote',
    defaultMessage: 'All slots are full. Unfollow one on Watchlist, or upgrade.',
  },
  recentTitle: { id: 'app.sml.browse.recent.title', defaultMessage: 'Recent searches' },
  recentClear: { id: 'app.sml.browse.recent.clear', defaultMessage: 'Clear' },
  pill: { id: 'app.sml.browse.credits.pill', defaultMessage: '{left} / {limit}' },
  pillLabel: { id: 'app.sml.browse.credits.pillLabel', defaultMessage: 'Browse credits: {left} of {limit} left today' },
  navMeter: { id: 'app.sml.browse.credits.navMeter', defaultMessage: '{left} of {limit} opens left today' },
});

/** The copy of a Follow or Unfollow on a Browse row that failed. */
export const browseFollowMessages = defineMessages({
  failed: {
    id: 'app.sml.browse.follow.failed',
    defaultMessage: 'We could not change the follow. Try again.',
  },
});
